"use client";

import { c as _c } from "react/compiler-runtime";
import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from "nuqs";
import { QUERY_PARAM_KEYS } from "./keys";
const STATUSES = ["yourOffers", "all"];
export function useCollectionOfferStatusQueryParam(t0) {
  const $ = _c(10);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? ["all"] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const defaultStatuses = t1;
  let t2;
  if ($[2] !== defaultStatuses) {
    t2 = parseAsArrayOf(parseAsStringLiteral(STATUSES)).withDefault(defaultStatuses);
    $[2] = defaultStatuses;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [statuses, setStatuses] = useQueryState(QUERY_PARAM_KEYS.collectionOfferStatus, t2);
  let t3;
  if ($[4] !== setStatuses || $[5] !== statuses) {
    t3 = async function onSelectCollectionOfferStatus(status) {
      if (status === "all" && !statuses.includes("all")) {
        await setStatuses(["all"]);
        return;
      }
      const newStatuses = (statuses.includes(status) ? statuses.filter(s => s !== status) : [...statuses, status]).filter(_temp);
      await setStatuses(newStatuses.length > 0 ? newStatuses : ["all"]);
    };
    $[4] = setStatuses;
    $[5] = statuses;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onSelectCollectionOfferStatus = t3;
  let t4;
  if ($[7] !== onSelectCollectionOfferStatus || $[8] !== statuses) {
    t4 = {
      collectionOfferStatuses: statuses,
      onSelectCollectionOfferStatus
    };
    $[7] = onSelectCollectionOfferStatus;
    $[8] = statuses;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(s_0) {
  return s_0 !== "all";
}